import type { ContactBarV1Attributes } from '@/features/contact-bar-v1/contact-bar-v1-type';

import { EmailIcon } from '@/assets/icons/email';
import { PhoneIcon } from '@/assets/icons/phone';
import { WebIcon } from '@/assets/icons/web';
import { Link } from '@/core/features';
import color from '@/core/features/styles/color';

import styles from './contact-bar-desktop.module.scss';

export type ContactBarDesktopProps = ContactBarV1Attributes;

export default function ContactBarDesktop({ links }: ContactBarDesktopProps) {
    return (
        <div className={styles.mainWrapper}>
            {links.phone && (
                <a
                    className={styles.wrapper}
                    href={links.phone.linkUrl}
                >
                    <div className={`flex-center ${styles.iconLink}`}>
                        <PhoneIcon
                            color={color('endeavour')}
                            width={18}
                        />
                    </div>
                    <div className={`line-clamp-1 ${styles.title}`}>{links.phone.title}</div>
                </a>
            )}
            {links.email && (
                <a
                    className={styles.wrapper}
                    href={links.email.linkUrl}
                >
                    <div className={`flex-center ${styles.iconLink}`}>
                        <EmailIcon
                            color={color('endeavour')}
                            width={18}
                        />
                    </div>
                    <div className={`line-clamp-1 ${styles.title}`}>{links.email.title}</div>
                </a>
            )}
            {links.homepage && (
                <Link
                    href={links.homepage.linkUrl}
                    linkType={'external'}
                    target={'_blank'}
                >
                    <div className={styles.wrapper}>
                        <div className={`flex-center ${styles.iconLink}`}>
                            <WebIcon
                                color={color('endeavour')}
                                width={18}
                            />
                        </div>
                        <div className={`line-clamp-1 ${styles.title}`}>{links.homepage.title}</div>
                    </div>
                </Link>
            )}
        </div>
    );
}
